import { orderFillsByVenueCapsuleDescription } from './components/description/orderFillsByVenueCapsuleDescription';
import { toVenueExecCapsuleData } from '../venueExecCapsule/components/content/venueExecCapsuleData';
import { Tooltip } from '@instinet-analytics/core-lib';
import React from 'react';
import { OrderFillsCapsuleStrategy } from '../orderFillsCapsulesShared/orderFillsCapsuleStrategy';
import { VenueAnalysisVenueData } from 'widgets/venueAnalysis/venueAnalysisAggregatedData';

export const orderFillsByVenueCapsuleStrategy: OrderFillsCapsuleStrategy = {
    title: 'Order Fills by Venue',
    description: orderFillsByVenueCapsuleDescription,
    helpText: `This capsule displays your order's breakdown of execution venues that it has traded in.`,
    getOrderDisplayData: (data) =>
        toVenueExecCapsuleData(data).orderDisplayData,
    renderLabel: (v, percentText: string) => (
        <Tooltip text={`${displayName(v)} (${percentText})`}>
            {v.micCode}
        </Tooltip>
    ),
};

function displayName(v: VenueAnalysisVenueData) {
    if (v.name && v.name !== 'None') {
        return `${v.micCode} - ${v.name}`;
    }
    return v.micCode;
}
